export const SEARCH_TRACK_EVENT = {
  CATEGORY: 'Recherche',
  ALL_MAGISTRATE: 'Tous les magistrats',
  MAGISTRATE_YEAR: 'Magistrats nommés en {{year}}',
  START_SEARCH: 'Lance une recherche',
  PAGE: "Page d'accueil",
};
